module.exports = __webpack_public_path__ + "static/media/drawer-profile-icon.ee201dad.svg";